<template>
    <div class="g-top index nav-bg">
        <div class="g-wrap">
            <div class="m-logo f-left">产业人才数据中心</div>

            <ul class="m-nav f-left">
                <li><a href="/index.html" name="tab01">首页</a></li>
                <li class="secnav">
                    <a href="/api.html" name="tab02"  :class="{'cur':cur===1}">数据中心</a>
<!--                    <ul class="m-subnav">-->
<!--                        <li><a href="/dsdatavisual.html" target="_blank">电子商务</a></li>-->
<!--                        <li><a href="/xskdatavisual.html" target="_blank">新商科</a></li>-->
<!--                        <li><a href="/visual/industry/tourism.html" target="_blank">旅游</a></li>-->
<!--                        <li><a href="/visual/industry/mba.html" target="_blank">工商管理</a></li>-->
<!--                    </ul>-->
                </li>
                <li><a href="http://pedigree.apdata.com.cn/" name="tab03" target="_blank">谱系图</a></li>
<!--                <li><a href="/api.html" name="tab03" :class="{'cur':cur===2}">数据API</a></li>-->
<!--                <li><a href="/content.html" name="tab04" :class="{'cur':cur===3}">资源中心</a></li>-->
            </ul>
<!--            <div class="m-role f-right" v-if="useraccount">-->
<!--                <div class="rolephoto f-left">-->
<!--                    <img v-if="imageUrl" :src="imageUrl"-->
<!--                         width="46"-->
<!--                         height="46">-->
<!--                </div>-->
<!--                <div class="roleinfo f-right">-->
<!--                    <p>{{useraccount}}</p>-->
<!--                    <div class="role">-->
<!--                        <span class="role">{{usermem}}<i class="icon-arrd"></i></span>-->
<!--                        <div>-->
<!--                            <a href="/user.html">用户中心</a>-->
<!--                            <a @click="loginout()">退出</a>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="m-role f-right" v-else>-->
<!--                <div class="rolephoto f-left"></div>-->
<!--                <div class="roleinfo f-right">-->
<!--                    <p class="tologin"> <a @click="login()">登录</a></p>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <loginer ref="loginer"></loginer>
    </div>
</template>

<script>
    import Loginer from "./loginer";
    export default {
        name: "headertab",
        components: {Loginer},
        props: {
            cur: {type:Number,default:-1}
        },
        data() {
            return {
                // user:{},
                // showdiv:'',
                // useraccount:'',
                // imageUrl:"",
                // membername:{"1000101":"数据大会员","1000102":"报告大会员","1000103":"高级会员"}
            };
        },
        computed: {
            useraccount(){
                return this.$store.state.user.useraccount;
            },
            imageUrl(){
                return this.$store.state.user.picname ? ("/RESOURCE/" + this.$store.state.user.picurl + "/" + this.$store.state.user.picname) : "";
            },
            usertype(){
                return this.$store.state.user.usertype;
            },
            usermem(){
                return this.$store.state.user.mem;
            }
        },
        created() {
            this.init();
        },
        methods: {
            login() {
                this.$refs.loginer.show();
            },
            async loginout(){
                await this.ajax.getJson('/webtoken/logout.do');
                this.$store.commit("clearUser");
                location.reload();
            },
            async init() {
                if (!this.useraccount) {
                    let user = await this.ajax.getJson('/registerbytdp');
                    if (Object.keys(user).length) {
                        this.$store.commit("setUser", user);
                    }
                }
            },
        }
    };
</script>

<style scoped>

</style>
